module.exports = __webpack_public_path__ + "Joseph Zhang-0e8ec286.png";